import React from 'react';
import './landingPage.css';
import Grid from '@mui/material/Grid'
import {Button} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ImgMediaCard from './cardDeals';
import { Link } from 'react-router-dom';

import hekouAncient from '../../assets/images/hekouAncient.jpeg'
import shanghai from '../../assets/images/shanghai.jpg'
import bangkok from '../../assets/images/bangkok.jpg'

import { useTranslation } from 'react-i18next';
import '../../i18n';

const DealsShow =() => {
        const { t } = useTranslation(); // t is the translation function
        return (
            <section className="white-section" id="Menu">
                <div className="container-fluid">

                <h2 className="section-heading">{t('landingPage:deals.all-deals-title')}</h2>
                <p>{t('landingPage:deals.all-deals-context')}</p>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={bangkok}
                    name={t('landingPage:deals.deal-1-title')}
                    description={t('landingPage:deals.deal-1-description')}
                    />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={shanghai}
                    name={t('landingPage:deals.deal-2-title')}
                    description={t('landingPage:deals.deal-2-description')}
                    />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <ImgMediaCard
                    image={hekouAncient}
                    name={t('landingPage:deals.deal-3-title')}
                    description={t('landingPage:deals.deal-3-description')}
                    />
                    </Grid>
                </Grid>
                <hr></hr>
                        
                <Button className="button-moreDeal" size="large" endIcon={<SendIcon />}>
                <Link to='/discover' style={{ textDecoration: 'none'}}>    
                    {t('landingPage:deals.more-button')}
                </Link>
                </Button>
    
                </div>
  </section>
)}
export default DealsShow;
